export const SUBMISSION_FETCH = 'SUBMISSION_FETCH';
export const SUBMISSION_RESET = 'SUBMISSION_RESET';
export const SUBMISSION_SET_SCHEMA_COLUMNS = 'SUBMISSION_SET_SCHEMA_COLUMNS';
export const SUBMISSION_UPDATE_SCHEMA_COLUMN = 'SUBMISSION_UPDATE_SCHEMA_COLUMN';
export const SUBMISSION_VALIDATE_SCHEMA_COLUMN = 'SUBMISSION_VALIDATE_SCHEMA_COLUMN';
// export const SUBMISSION_UPDATE_SCHEMA_COLUMNS = 'SUBMISSION_UPDATE_SCHEMA_COLUMNS';
export const CATEGORY_SCHEMAS_FETCHED = 'CATEGORY_SCHEMAS_FETCHED';
